import(/* webpackMode: "eager" */ "/var/www/kst-frontend-staging/app/benefits-for-customers/page.tsx")